var map = {
	"./black/fenzu2.png": "oeDY",
	"./blue/fenzu2.png": "OchU",
	"./white/fenzu2.png": "o7lV"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "PfMj";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/fenzu2\.png$
// module id = PfMj
// module chunks = 24